import { Container } from 'semantic-ui-react';

const GridStyleWrapper = (Component) => ({ ...props }) => {

  return (
    <div className={props.className}>
      <Container >
        <Component {...props} className="" />
      </Container>
      </div>
  );
};

export default GridStyleWrapper;
